import { Box, Chip, Grid, Stack, TextField, Typography } from '@mui/material'
import { toastHelper } from '../../../util/toastHelper'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import Style from '../../molecules/VenderModal/VendorModal.module.scss'
import Stepper from '../../atoms/Stepper/Stepper'
import { BUSINESS_PROFILE_TOTAL_STEPS, STACKS } from '../../../util/constants'

export const BusinessTypeModal = ({
	step,
	setStep,
	formData,
	setFormData,
	onUpdateProfile,
	saving = false,
}) => {
	const { businessTypes, customBusinessType } = formData
	const changeType = (label) => {
		const type = businessTypes?.includes(label)
			? businessTypes.filter((item) => item !== label)
			: [...businessTypes, label]
		setFormData({ ...formData, businessTypes: type })
	}

	return (
		<>
			<Grid size={{ xs: 12, sm: 12 }} className={Style.formContainer}>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'space-between',
						minHeight: '80%',
						height: '100%',
						gap: '30px',
					}}
					className={Style.titleContainer}
				>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
						}}
					>
						<Typography
							variant="h3"
							gutterBottom
							className={Style.title}
						>
							Business Types
						</Typography>
						<Typography
							variant="h6"
							className={Style.modalSemiTitle}
						>
							Select business types
						</Typography>
					</Box>
					<Box
						sx={{
							width: 'auto',
							display: 'grid',
							gridTemplateColumns: 'repeat(3, 1fr)',
							gap: '16px',
							alignItems: 'start',
							'@media (max-width: 599px)': {
								gridTemplateColumns: 'repeat(2, 1fr)',
							},
							'@media (max-width: 499px)': {
								gridTemplateColumns: 'repeat(1, 1fr)',
								width: '100%',
							},
						}}
					>
						{STACKS.map((stack, idx) => (
							<Stack
								key={idx}
								sx={{
									display: 'grid',
									gridTemplateColumns:
										'repeat(auto-fill, minmax(200px, 1fr))',
									gap: '16px',
								}}
							>
								{stack.map((label) => (
									<Chip
										key={label}
										disableRipple
										variant="outlined"
										label={label}
										sx={{
											bgcolor: `${businessTypes?.includes(label) ? '#7ca6bd' : '#FFF'}`,
											color: `${businessTypes?.includes(label) ? '#FFF' : '#7ca6bd'}`,
											borderColor: '#DFE4EB',
											padding: '10px 12px',
											font: 'var(--body-font-three)',
											fontWeight: '400',
										}}
										onClick={() => changeType(label)}
									/>
								))}
							</Stack>
						))}
						<Stack
							sx={{
								display: 'flex',
								justifyContent: 'start',
								width: '100%',
								gap: '16px',
								gridColumn: 'span 3',
								'@media (max-width: 599px)': {
									gridColumn: 'span 2',
								},
								'@media (max-width: 499px)': {
									gridColumn: 'span 1',
								},
							}}
						>
							<TextField
								data-cy="custom"
								disableRipple
								placeholder="Other (Custom Entry)"
								value={formData.customBusinessType}
								sx={{
									borderRadius: '2em',
									justifyContent: 'start',
									bgcolor: 'white',
									margin: '0',
									'.MuiInputBase-input': {
										padding: '10px 10px 10px 10px',
										fontSize: '14px',
										fontWeight: '400',
										color: '#313131',
									},

									'& label.MuiInputLabel-root': {
										color: '#7ca6bd',
									},
									'& .MuiInputBase-input.Mui-disabled': {
										color: '#313131',
										WebkitTextFillColor: 'black',
										opacity: 1,
										padding: '10px 10px 10px 0',
										fontSize: '14px',
										fontWeight: '400',
									},
									'& .MuiOutlinedInput-root': {
										borderRadius: '2em',
										'& > fieldset': {
											borderColor: '#DFE4EB !important',
										},
									},
								}}
								onChange={(e) => {
									setFormData({
										...formData,
										customBusinessType: e.target.value,
									})
								}}
							/>
						</Stack>
					</Box>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'space-between',
							gap: '10px',
							width: '100%',
							'@media (max-width: 499px)': {
								flexWrap: 'wrap',
								justifyContent: 'center',
								width: '100%',
							},
						}}
					>
						<Box
							className={Style.buttonContainer}
							sx={{
								justifyContent: 'space-between',
								alignItems: 'center',
							}}
						>
							<Box
								sx={{
									display: 'flex',
									'@media (max-width: 499px)': {
										display: 'none',
									},
								}}
							>
								<Stepper
									totalSteps={BUSINESS_PROFILE_TOTAL_STEPS}
									subSteps={1}
									activeStep={step}
								/>
							</Box>
							<Box
								sx={{
									display: 'flex',
									justifyContent: 'flex-end',
									gap: '16px',
									'@media (max-width: 499px)': {
										justifyContent: 'space-between',
										width: '100%',
									},
								}}
							>
								<ButtonCustom
									onClick={() => setStep((step) => step - 1)}
									className="backButton"
								>
									Previous
								</ButtonCustom>
								<ButtonCustom
									disabled={saving}
									onClick={() => {
										if (
											businessTypes?.length > 0 ||
											!!customBusinessType
										) {
											onUpdateProfile(() =>
												setStep((step) => step + 1)
											)
											return
										}
										toastHelper(
											'Please select a business type',
											'error'
										)
									}}
								>
									{saving ? 'Saving…' : 'Next'}
								</ButtonCustom>
							</Box>
						</Box>
						<Box
							sx={{
								justifyContent: 'center',
								alignItems: 'center',
								display: 'none',
								'@media (max-width: 499px)': {
									display: 'flex',
								},
							}}
						>
							<Stepper
								totalSteps={BUSINESS_PROFILE_TOTAL_STEPS}
								subSteps={1}
								activeStep={step}
							/>
						</Box>
					</Box>
				</Box>
			</Grid>
		</>
	)
}
